// import React, { useState, useEffect, useCallback, useMemo } from "react";
// import {
//   Box,
//   Typography,
//   Button,
//   Chip,
//   Tooltip
// } from "@mui/material";
// import { useNavigate, useSearchParams } from "react-router-dom";
// import StyledDataGrid from "../../components/StyledDataGrid";
// import { formatDate, formatDateUTC } from "../../utils/formatDateTime";
// import PageHeader from "../../components/PageHeader";
// import { searchAdminPatients, fetchIRBStudyFilters, fetchStudies } from "../../utils/api";
// import FilterDropdownGroup from "./FilterDropdownGroup";
// import { PATIENT_FILTER_FIELDS } from "./patientFilterConfig";
// import { BASE_CHIP_SX, getStatusChipStyle, STATUS_CHIP_STYLES } from "../../constants/statusColors";
// import { ADMIN_ROUTES } from "../../constants/routes";

// const GroupTitles = {
//   personal: "Personal Information",
//   medical: "Medical and Family History",
//   lifestyle: "Lifestyle",
//   research: "Research and REDCap",
// };

// const URL_ARRAY_FILTERS = new Set([
//   "ethnicity",
//   "state",
//   "medicalHistory",
//   "familyHistory",
//   "irbStudies",
// ]);

// const PatientData = () => {
//   const navigate = useNavigate();
//   const [searchParams, setSearchParams] = useSearchParams();

//   // Initialize state from URL params
//   const initialFilters = useMemo(() => {
//     const filters = {};
//     for (const [key, value] of searchParams.entries()) {
//       if (key !== "page" && key !== "pageSize") {
//         if (URL_ARRAY_FILTERS.has(key)) {
//           if (filters[key]) {
//             filters[key] = [...filters[key], value];
//           } else {
//             filters[key] = [value];
//           }
//         } else {
//           filters[key] = value;
//         }
//       }
//     }
//     return filters;
//   }, [searchParams]);

//   const [appliedFilters, setAppliedFilters] = useState(initialFilters);
//   const [studiesOptions, setStudiesOptions] = useState([]);

//   const [patients, setPatients] = useState([]);
//   const studiesMapRef = React.useRef(null);
//   const [loading, setLoading] = useState(false);

//   const initialPage = parseInt(searchParams.get("page") || "0", 10);
//   const initialPageSize = parseInt(searchParams.get("pageSize") || "25", 10);

//   const [pagination, setPagination] = useState({
//     page: initialPage,
//     pageSize: initialPageSize,
//     total: 0,
//   });

//   const [sortModel, setSortModel] = useState([
//     { field: "patientAccountNumber", sort: "asc" }
//   ]);

//   // Load studies options once
//   useEffect(() => {
//     const loadStudies = async () => {
//       try {
//         const response = await fetchIRBStudyFilters();
//         if (Array.isArray(response)) {
//            const opts = response.map(r => {
//              if (typeof r === 'string') return { label: r, value: r };
//              const studyId = r.irbStudy;
//              const studyName = r.studyName;
//              return {
//                label: studyId && studyName ? `${studyId}: ${studyName}` : (studyId || studyName || 'Unknown'),
//                value: studyId
//              };
//            }).filter(opt => opt.value);
//            setStudiesOptions(opts);
//         }
//       } catch (err) {
//         console.error("Failed to load studies", err);
//       }
//     };
//     loadStudies();
//   }, []);

//   // Sync state to URL whenever it changes
//   useEffect(() => {
//     const params = new URLSearchParams();
//     params.set("page", pagination.page);
//     params.set("pageSize", pagination.pageSize);

//     Object.entries(appliedFilters).forEach(([k, v]) => {
//       if (Array.isArray(v) && v.length > 0) {
//         v.forEach(val => params.append(k, val));
//       } else if (v && !Array.isArray(v)) {
//         params.set(k, String(v));
//       }
//     });

//     setSearchParams(params, { replace: true });
//   }, [appliedFilters, pagination.page, pagination.pageSize, setSearchParams]);

//   const fetchPatients = useCallback(async () => {
//     setLoading(true);
//     try {

//       // Map UI keys to API keys
//       const keyMap = {
//         gender: "genders",
//         ethnicity: "ethnicities",
//         state: "states",
//       };

//       const listFields = [
//         "genders", "ethnicities", "states", "medicalHistory", "familyHistory",
//         "smoking", "drinking", "exercise", "irbStudies", "redcapMatchStatuses"
//       ];

//       // Fields that are handled separately
//       const excludedRootFields = [
//         "medicalHistory", "medicalHistoryOther", "medicalHistoryValuesOperator",
//         "familyHistory", "familyHistoryOther", "familyHistoryValuesOperator",
//         "medicalFamilyOperator"
//       ];

//       // Cleanup and map applied filters before sending
//       const cleanedFilters = Object.entries(appliedFilters).reduce((acc, [k, v]) => {
//         if (excludedRootFields.includes(k)) return acc;

//         const apiK = keyMap[k] || k;
//         let valueToSet;

//         if (Array.isArray(v) && v.length > 0) {
//           valueToSet = v;
//         } else if (typeof v === 'string' && v.trim() !== "") {
//           valueToSet = listFields.includes(apiK) ? [v] : v;
//         }

//         if (valueToSet !== undefined) {
//           acc[apiK] = valueToSet;
//         }
//         return acc;
//       }, {});

//       // Extract history fields
//       const medicalValues = Array.isArray(appliedFilters.medicalHistory) ? appliedFilters.medicalHistory : [];
//       const medicalOther = typeof appliedFilters.medicalHistoryOther === 'string' ? appliedFilters.medicalHistoryOther.trim() : "";
//       const familyValues = Array.isArray(appliedFilters.familyHistory) ? appliedFilters.familyHistory : [];
//       const familyOther = typeof appliedFilters.familyHistoryOther === 'string' ? appliedFilters.familyHistoryOther.trim() : "";

//       // Only append history if there is any medical or family search criteria
//       if (medicalValues.length > 0 || medicalOther !== "" || familyValues.length > 0 || familyOther !== "") {
//         cleanedFilters.history = {
//           medical: {
//             values: medicalValues,
//             valuesOperator: appliedFilters.medicalHistoryValuesOperator || "ANY",
//             otherText: medicalOther
//           },
//           family: {
//             values: familyValues,
//             valuesOperator: appliedFilters.familyHistoryValuesOperator || "ANY",
//             otherText: familyOther
//           },
//           medicalFamilyOperator: appliedFilters.medicalFamilyOperator || "AND"
//         };
//       }

//       const request = {
//         page: pagination.page,
//         size: pagination.pageSize,
//         filters: cleanedFilters,
//       };

//       if (sortModel.length > 0) {
//         const sortFieldMap = {
//           "patientAccountNumber": "PATIENT_ACCOUNT_NUMBER",
//           "name": "LAST_NAME",
//           "dateOfBirth": "BIRTH_DATE",
//           "gender": "GENDER",
//           "state": "STATE",
//           "redcapMatchStatus": "REDCAP_MATCH_STATUS",
//           "lastVisit": "LAST_VISIT_DATE"
//         };
//         const mappedField = sortFieldMap[sortModel[0].field] || sortModel[0].field.toUpperCase();
//         request.sort = {
//           field: mappedField,
//           direction: sortModel[0].sort.toUpperCase()
//         };
//       }

//       const response = await searchAdminPatients(request);

//       if (!studiesMapRef.current) {
//         const studies = await fetchStudies().catch(() => []);
//         const map = {};
//         (studies || []).forEach(s => {
//           map[s.irbStudy] = s.studyShortName || s.irbStudy;
//         });
//         studiesMapRef.current = map;
//       }

//       if (response && response.content) {
//         const transformedPatients = response.content.map((patient, index) => {
//           return {
//             id: patient.id || index,
//             patientAccountNumber: patient.patientAccountNumber || "—",
//             name: patient.name || "—",
//             dateOfBirth: patient.dateOfBirth ? formatDateUTC(patient.dateOfBirth) : "—",
//             gender: patient.gender || "—",
//             state: patient.state || "—",
//             studyIds: (patient.irbStudies || []).map((study) => {
//               const normalizedStudy = typeof study === "string"
//                 ? { irbStudy: study, status: null }
//                 : study;
//               return {
//                 ...normalizedStudy,
//                 label: studiesMapRef.current[normalizedStudy.irbStudy] || normalizedStudy.irbStudy,
//               };
//             }),
//             consentStatus: patient.consentStatus || "INACTIVE",
//             verifiedPdf: patient.verifiedPdf || "No",
//             redcapMatchStatus: patient.redcapMatchStatus || "—",
//             lastVisit: patient.lastVisit ? formatDate(patient.lastVisit) : "—",
//             rawPatient: patient
//           };
//         });

//         setPatients(transformedPatients);
//         setPagination((prev) => ({
//           ...prev,
//           total: response.totalElements || transformedPatients.length,
//         }));
//       } else {
//         setPatients([]);
//         setPagination((prev) => ({ ...prev, total: 0 }));
//       }
//     } catch (error) {
//       console.error("Error fetching patients:", error);
//       setPatients([]);
//       setPagination((prev) => ({ ...prev, total: 0 }));
//     } finally {
//       setLoading(false);
//     }
//   }, [appliedFilters, pagination.page, pagination.pageSize, sortModel]);

//   useEffect(() => {
//     // We add a debounce effect here for typing text filters directly applying
//     const handler = setTimeout(() => {
//       fetchPatients();
//     }, 500);
//     return () => clearTimeout(handler);
//   }, [fetchPatients]);

//   const handleFilterChange = (key, value) => {
//     setAppliedFilters(prev => ({ ...prev, [key]: value }));
//     setPagination(prev => ({ ...prev, page: 0 }));
//   };

//   const handleClearAllFilters = () => {
//     setAppliedFilters({});
//     setPagination(prev => ({ ...prev, page: 0 }));
//   };

//   const columns = [
//     { field: "patientAccountNumber", headerName: "MRN", width: 90 },
//     { field: "name", headerName: "Name", minWidth: 200 },
//     { field: "dateOfBirth", headerName: "Date of Birth", width: 120 },
//     { field: "gender", headerName: "Gender", width: 80 },
// //     {
//       field: "studyIds",
//       headerName: "Study",
//       minWidth: 180,
//       flex: 1,
//       sortable: false,
//       renderCell: (params) => {
//         const studies = Array.isArray(params.value) ? params.value : [];
//         if (studies.length === 0) return "—";
//         return (
//           <Box sx={{ display: "flex", gap: 0.75, alignItems: "center", overflow: "hidden" }}>
//             {studies.map((study) => {
//               const statusStr = study.status ? study.status.toUpperCase() : "UNKNOWN";
//               const pdfStr = study.verifiedPdf?.toUpperCase() === "YES" ? "PDF VERIFIED" : study.verifiedPdf?.toUpperCase() === "PARTIAL" ? "PDF PARTIAL" : "PDF NOT FOUND";
//               return (
//                 <Tooltip
//                   key={study.irbStudy}
//                   title={`${statusStr}; ${pdfStr}`}
//                   arrow
//                 >
//                 <Chip
//                   label={study.label}
//                   size="small"
//                   sx={{
//                     ...BASE_CHIP_SX,
//                     backgroundColor: "#ffffff",
//                     color: "#500000",
//                     border: "1px solid #500000",
//                     pointerEvents: "auto",
//                     flexShrink: 0,
//                   }}
//                 />
//               </Tooltip>
//               );
//             })}
//           </Box>
//         );
//       },
//     },
//     {
//       field: "consentStatus",
//       headerName: "Consent Status",
//       width: 140,
//       sortable: false,
//       renderCell: (params) => (
//         <Chip
//           label={params.value}
//           size="small"
//           sx={{ ...BASE_CHIP_SX, ...getStatusChipStyle(params.value) }}
//         />
//       ),
//     },
//     {
//       field: "verifiedPdf",
//       headerName: "Verified PDF",
//       width: 110,
//       sortable: false,
//       renderCell: (params) => (
//         <Chip
//           label={params.value}
//           size="small"
//           sx={{
//             ...BASE_CHIP_SX,
//             ...getStatusChipStyle(params.value),
//           }}
//         />
//       ),
//     },
//     {
//       field: "redcapMatchStatus",
//       headerName: "REDCap Status",
//       width: 150,
//       renderCell: (params) => {
//         const isMatched = params.value && String(params.value).toUpperCase() === "MATCHED";
//         const label = isMatched ? "Matched" : "Unmatched";
//         const statusKey = isMatched ? "MATCHED" : "UNMATCHED";
//         return (
//           <Chip
//             label={label}
//             size="small"
//             sx={{
//               ...BASE_CHIP_SX,
//               ...getStatusChipStyle(statusKey),
//             }}
//           />
//         );
//       },
//     },
//   ];

//   const handlePatientClick = (patient) => {
//     navigate(ADMIN_ROUTES.PATIENT_PROFILE, { state: { patient: patient.rawPatient } });
//   };

//   const groupedFields = Object.entries(PATIENT_FILTER_FIELDS).reduce((acc, [key, config]) => {
//     if (!acc[config.group]) acc[config.group] = [];
//     acc[config.group].push({ key, ...config });
//     return acc;
//   }, {});

//   const groupKeys = ["personal", "medical", "lifestyle", "research"];

//   return (
//     <Box sx={{ p: 3, height: "calc(100vh - 96px)", display: "flex", flexDirection: "column", bgcolor: "#fff", overflow: "hidden" }}>
//       <PageHeader title="Participant Data" />

//       {/* Top Filter Bar */}
//       <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2, flexWrap: 'wrap', gap: 2 }}>
//         <Box sx={{ display: "flex", gap: 2, alignItems: "center", flexWrap: 'wrap' }}>
//           <Typography variant="body1" sx={{ fontWeight: 'bold', color: '#500000', mr: 1 }}>
//             Search by
//           </Typography>
//           {groupKeys.map(groupKey => {
//              const fields = groupedFields[groupKey] || [];
//              if (fields.length === 0) return null;
//              return (
//                <FilterDropdownGroup
//                  key={groupKey}
//                  title={GroupTitles[groupKey] || groupKey}
//                  fields={fields}
//                  filters={appliedFilters}
//                  onChange={handleFilterChange}
//                  studiesOptions={studiesOptions}
//                />
//              );
//           })}
//           {Object.keys(appliedFilters).some(k => appliedFilters[k] && appliedFilters[k].length > 0) && (
//             <Button variant="text" color="error" onClick={handleClearAllFilters}>
//               Clear All
//             </Button>
//           )}
//         </Box>
//         <Typography variant="body2" sx={{ color: "#500000", fontWeight: 700 }}>
//           {pagination.total} {pagination.total === 1 ? "participant" : "participants"}
//         </Typography>
//       </Box>

//       <Box sx={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}>
//         <StyledDataGrid
//           sx={{ flex: 1 }}
//           rows={patients}
//           columns={columns}
//           pageSizeOptions={[10, 25, 50]}
//           pagination
//           paginationMode="server"
//           sortingMode="server"
//           rowCount={pagination.total}
//           paginationModel={{ page: pagination.page, pageSize: pagination.pageSize }}
//           onSortModelChange={(model) => {
//             setSortModel(model);
//             setPagination((prev) => ({ ...prev, page: 0 }));
//           }}
//           onPaginationModelChange={(model) => {
//             setPagination((prev) => ({ ...prev, page: model.page, pageSize: model.pageSize }));
//           }}
//           disableSelectionOnClick
//           loading={loading}
//           onRowClick={(params) => handlePatientClick(params.row)}
//         />
//       </Box>
//     </Box>
//   );
// };

// export default PatientData;
import React, { useState, useEffect, useCallback, useMemo } from "react";
import { Box, Typography, Button, Chip, Tooltip } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";
import StyledDataGrid from "../../components/StyledDataGrid";
import { formatDate, formatDateUTC } from "../../utils/formatDateTime";
import PageHeader from "../../components/PageHeader";
import {
  searchAdminPatients,
  fetchIRBStudyFilters,
  fetchStudies,
} from "../../utils/api";
import FilterDropdownGroup from "./FilterDropdownGroup";
import { PATIENT_FILTER_FIELDS } from "./patientFilterConfig";
import { ALZHEIMERS_STATUS_OPTIONS } from "../../constants/patientOptions";
import {
  BASE_CHIP_SX,
  getStatusChipStyle,
  STATUS_CHIP_STYLES,
} from "../../constants/statusColors";
import { ADMIN_ROUTES } from "../../constants/routes";

const ALZHEIMERS_STATUS_LABELS = ALZHEIMERS_STATUS_OPTIONS.reduce(
  (acc, opt) => ({ ...acc, [opt.value]: opt.label }),
  {},
);

const GroupTitles = {
  personal: "Personal Information",
  medical: "Medical and Family History",
  lifestyle: "Lifestyle",
  research: "Research and REDCap",
};

const URL_ARRAY_FILTERS = new Set([
  "ethnicity",
  "state",
  "medicalHistory",
  "familyHistory",
  "irbStudies",
]);

const PatientData = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  // Initialize state from URL params
  const initialFilters = useMemo(() => {
    const filters = {};
    for (const [key, value] of searchParams.entries()) {
      if (key !== "page" && key !== "pageSize") {
        if (URL_ARRAY_FILTERS.has(key)) {
          if (filters[key]) {
            filters[key] = [...filters[key], value];
          } else {
            filters[key] = [value];
          }
        } else {
          filters[key] = value;
        }
      }
    }
    return filters;
  }, [searchParams]);

  const [appliedFilters, setAppliedFilters] = useState(initialFilters);
  const [studiesOptions, setStudiesOptions] = useState([]);

  const [patients, setPatients] = useState([]);
  const studiesMapRef = React.useRef(null);
  const [loading, setLoading] = useState(false);

  const initialPage = parseInt(searchParams.get("page") || "0", 10);
  const initialPageSize = parseInt(searchParams.get("pageSize") || "25", 10);

  const [pagination, setPagination] = useState({
    page: initialPage,
    pageSize: initialPageSize,
    total: 0,
  });

  const [sortModel, setSortModel] = useState([
    { field: "patientAccountNumber", sort: "asc" },
  ]);

  // Load studies options once
  useEffect(() => {
    const loadStudies = async () => {
      try {
        const response = await fetchIRBStudyFilters();
        if (Array.isArray(response)) {
          const opts = response
            .map((r) => {
              if (typeof r === "string") return { label: r, value: r };
              const studyId = r.irbStudy;
              const studyName = r.studyName;
              return {
                label:
                  studyId && studyName
                    ? `${studyId}: ${studyName}`
                    : studyId || studyName || "Unknown",
                value: studyId,
              };
            })
            .filter((opt) => opt.value);
          setStudiesOptions(opts);
        }
      } catch (err) {
        console.error("Failed to load studies", err);
      }
    };
    loadStudies();
  }, []);

  // Sync state to URL whenever it changes
  useEffect(() => {
    const params = new URLSearchParams();
    params.set("page", pagination.page);
    params.set("pageSize", pagination.pageSize);

    Object.entries(appliedFilters).forEach(([k, v]) => {
      if (Array.isArray(v) && v.length > 0) {
        v.forEach((val) => params.append(k, val));
      } else if (v && !Array.isArray(v)) {
        params.set(k, String(v));
      }
    });

    setSearchParams(params, { replace: true });
  }, [appliedFilters, pagination.page, pagination.pageSize, setSearchParams]);

  const fetchPatients = useCallback(async () => {
    setLoading(true);
    try {
      // Map UI keys to API keys
      const keyMap = {
        gender: "genders",
        ethnicity: "ethnicities",
        state: "states",
        alzheimersStatus: "alzheimersStatuses",
      };

      const listFields = [
        "genders",
        "ethnicities",
        "states",
        "medicalHistory",
        "familyHistory",
        "smoking",
        "drinking",
        "exercise",
        "irbStudies",
        "redcapMatchStatuses",
        "alzheimersStatuses",
      ];

      // Fields that are handled separately
      const excludedRootFields = [
        "medicalHistory",
        "medicalHistoryOther",
        "medicalHistoryValuesOperator",
        "familyHistory",
        "familyHistoryOther",
        "familyHistoryValuesOperator",
        "medicalFamilyOperator",
      ];

      // Cleanup and map applied filters before sending
      const cleanedFilters = Object.entries(appliedFilters).reduce(
        (acc, [k, v]) => {
          if (excludedRootFields.includes(k)) return acc;

          const apiK = keyMap[k] || k;
          let valueToSet;

          if (Array.isArray(v) && v.length > 0) {
            valueToSet = v;
          } else if (typeof v === "string" && v.trim() !== "") {
            valueToSet = listFields.includes(apiK) ? [v] : v;
          }

          if (valueToSet !== undefined) {
            acc[apiK] = valueToSet;
          }
          return acc;
        },
        {},
      );

      // Extract history fields
      const medicalValues = Array.isArray(appliedFilters.medicalHistory)
        ? appliedFilters.medicalHistory
        : [];
      const medicalOther =
        typeof appliedFilters.medicalHistoryOther === "string"
          ? appliedFilters.medicalHistoryOther.trim()
          : "";
      const familyValues = Array.isArray(appliedFilters.familyHistory)
        ? appliedFilters.familyHistory
        : [];
      const familyOther =
        typeof appliedFilters.familyHistoryOther === "string"
          ? appliedFilters.familyHistoryOther.trim()
          : "";

      // Only append history if there is any medical or family search criteria
      if (
        medicalValues.length > 0 ||
        medicalOther !== "" ||
        familyValues.length > 0 ||
        familyOther !== ""
      ) {
        cleanedFilters.history = {
          medical: {
            values: medicalValues,
            valuesOperator:
              appliedFilters.medicalHistoryValuesOperator || "ANY",
            otherText: medicalOther,
          },
          family: {
            values: familyValues,
            valuesOperator: appliedFilters.familyHistoryValuesOperator || "ANY",
            otherText: familyOther,
          },
          medicalFamilyOperator: appliedFilters.medicalFamilyOperator || "AND",
        };
      }

      const request = {
        page: pagination.page,
        size: pagination.pageSize,
        filters: cleanedFilters,
      };

      if (sortModel.length > 0) {
        const sortFieldMap = {
          patientAccountNumber: "PATIENT_ACCOUNT_NUMBER",
          name: "LAST_NAME",
          dateOfBirth: "BIRTH_DATE",
          gender: "GENDER",
          state: "STATE",
          redcapMatchStatus: "REDCAP_MATCH_STATUS",
          lastVisit: "LAST_VISIT_DATE",
        };
        const mappedField =
          sortFieldMap[sortModel[0].field] || sortModel[0].field.toUpperCase();
        request.sort = {
          field: mappedField,
          direction: sortModel[0].sort.toUpperCase(),
        };
      }

      const response = await searchAdminPatients(request);

      if (!studiesMapRef.current) {
        const studies = await fetchStudies().catch(() => []);
        const map = {};
        (studies || []).forEach((s) => {
          map[s.irbStudy] = s.studyShortName || s.irbStudy;
        });
        studiesMapRef.current = map;
      }

      if (response && response.content) {
        const transformedPatients = response.content.map((patient, index) => {
          return {
            id: patient.id || index,
            patientAccountNumber: patient.patientAccountNumber || "—",
            name: patient.name || "—",
            dateOfBirth: patient.dateOfBirth
              ? formatDateUTC(patient.dateOfBirth)
              : "—",
            gender: patient.gender || "—",
            state: patient.state || "—",
            alzheimersStatus: patient.alzheimersStatus || null,
            studyIds: (patient.irbStudies || []).map((study) => {
              const normalizedStudy =
                typeof study === "string"
                  ? { irbStudy: study, status: null }
                  : study;
              return {
                ...normalizedStudy,
                label:
                  studiesMapRef.current[normalizedStudy.irbStudy] ||
                  normalizedStudy.irbStudy,
              };
            }),
            consentStatus: patient.consentStatus || "INACTIVE",
            verifiedPdf: patient.verifiedPdf || "No",
            redcapMatchStatus: patient.redcapMatchStatus || "—",
            lastVisit: patient.lastVisit ? formatDate(patient.lastVisit) : "—",
            rawPatient: patient,
          };
        });

        setPatients(transformedPatients);
        setPagination((prev) => ({
          ...prev,
          total: response.totalElements || transformedPatients.length,
        }));
      } else {
        setPatients([]);
        setPagination((prev) => ({ ...prev, total: 0 }));
      }
    } catch (error) {
      console.error("Error fetching patients:", error);
      setPatients([]);
      setPagination((prev) => ({ ...prev, total: 0 }));
    } finally {
      setLoading(false);
    }
  }, [appliedFilters, pagination.page, pagination.pageSize, sortModel]);

  useEffect(() => {
    // We add a debounce effect here for typing text filters directly applying
    const handler = setTimeout(() => {
      fetchPatients();
    }, 500);
    return () => clearTimeout(handler);
  }, [fetchPatients]);

  const handleFilterChange = (key, value) => {
    setAppliedFilters((prev) => ({ ...prev, [key]: value }));
    setPagination((prev) => ({ ...prev, page: 0 }));
  };

  const handleClearAllFilters = () => {
    setAppliedFilters({});
    setPagination((prev) => ({ ...prev, page: 0 }));
  };

  const columns = [
    { field: "patientAccountNumber", headerName: "MRN", width: 90 },
    {
      field: "name",
      headerName: "Name",
      minWidth: 200,
      renderCell: (params) => (
        <Typography
          variant="body2"
          sx={{
            color: "#500000",
            fontWeight: 600,
            textDecoration: "underline",
            textDecorationColor: "transparent",
            "&:hover": { textDecorationColor: "#500000" },
          }}
        >
          {params.value}
        </Typography>
      ),
    },
    { field: "dateOfBirth", headerName: "Date of Birth", width: 120 },
    { field: "gender", headerName: "Gender", width: 80 },
    {
      field: "alzheimersStatus",
      headerName: "Alzheimer's Status",
      width: 150,
      sortable: false,
      renderCell: (params) => {
        if (!params.value) return "—";
        const label = ALZHEIMERS_STATUS_LABELS[params.value] || params.value;
        return (
          <Chip
            label={label}
            size="small"
            sx={{ ...BASE_CHIP_SX, ...getStatusChipStyle(params.value) }}
          />
        );
      },
    },
    {
      field: "studyIds",
      headerName: "Study",
      minWidth: 180,
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        const studies = Array.isArray(params.value) ? params.value : [];
        if (studies.length === 0) return "—";
        return (
          <Box
            sx={{
              display: "flex",
              gap: 0.75,
              alignItems: "center",
              overflow: "hidden",
            }}
          >
            {studies.map((study) => {
              const statusStr = study.status
                ? study.status.toUpperCase()
                : "UNKNOWN";
              const pdfStr =
                study.verifiedPdf?.toUpperCase() === "YES"
                  ? "PDF VERIFIED"
                  : study.verifiedPdf?.toUpperCase() === "PARTIAL"
                    ? "PDF PARTIAL"
                    : "PDF NOT FOUND";
              return (
                <Tooltip
                  key={study.irbStudy}
                  title={`${statusStr}; ${pdfStr}`}
                  arrow
                >
                  <Chip
                    label={study.label}
                    size="small"
                    sx={{
                      ...BASE_CHIP_SX,
                      backgroundColor: "#ffffff",
                      color: "#500000",
                      border: "1px solid #500000",
                      pointerEvents: "auto",
                      flexShrink: 0,
                    }}
                  />
                </Tooltip>
              );
            })}
          </Box>
        );
      },
    },
    {
      field: "consentStatus",
      headerName: "Consent Status",
      width: 140,
      sortable: false,
      renderCell: (params) => (
        <Chip
          label={params.value}
          size="small"
          sx={{ ...BASE_CHIP_SX, ...getStatusChipStyle(params.value) }}
        />
      ),
    },
    {
      field: "verifiedPdf",
      headerName: "Verified PDF",
      width: 110,
      sortable: false,
      renderCell: (params) => (
        <Chip
          label={params.value}
          size="small"
          sx={{
            ...BASE_CHIP_SX,
            ...getStatusChipStyle(params.value),
          }}
        />
      ),
    },
    {
      field: "redcapMatchStatus",
      headerName: "REDCap Status",
      width: 150,
      renderCell: (params) => {
        const isMatched =
          params.value && String(params.value).toUpperCase() === "MATCHED";
        const label = isMatched ? "Matched" : "Unmatched";
        const statusKey = isMatched ? "MATCHED" : "UNMATCHED";
        return (
          <Chip
            label={label}
            size="small"
            sx={{
              ...BASE_CHIP_SX,
              ...getStatusChipStyle(statusKey),
            }}
          />
        );
      },
    },
  ];

  const handlePatientClick = (patient) => {
    navigate(ADMIN_ROUTES.PATIENT_PROFILE, {
      state: { patient: patient.rawPatient },
    });
  };

  const groupedFields = Object.entries(PATIENT_FILTER_FIELDS).reduce(
    (acc, [key, config]) => {
      if (!acc[config.group]) acc[config.group] = [];
      acc[config.group].push({ key, ...config });
      return acc;
    },
    {},
  );

  const groupKeys = ["personal", "medical", "lifestyle", "research"];

  return (
    <Box
      sx={{
        p: 3,
        height: "calc(100vh - 96px)",
        display: "flex",
        flexDirection: "column",
        bgcolor: "#fff",
        overflow: "hidden",
      }}
    >
      <PageHeader title="Participant Data" />

      {/* Top Filter Bar */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
          flexWrap: "wrap",
          gap: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            gap: 2,
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          <Typography
            variant="body1"
            sx={{ fontWeight: "bold", color: "#500000", mr: 1 }}
          >
            Search by
          </Typography>
          {groupKeys.map((groupKey) => {
            const fields = groupedFields[groupKey] || [];
            if (fields.length === 0) return null;
            return (
              <FilterDropdownGroup
                key={groupKey}
                title={GroupTitles[groupKey] || groupKey}
                fields={fields}
                filters={appliedFilters}
                onChange={handleFilterChange}
                studiesOptions={studiesOptions}
              />
            );
          })}
          {Object.keys(appliedFilters).some(
            (k) => appliedFilters[k] && appliedFilters[k].length > 0,
          ) && (
            <Button
              variant="text"
              color="error"
              onClick={handleClearAllFilters}
            >
              Clear All
            </Button>
          )}
        </Box>
        <Typography variant="body2" sx={{ color: "#500000", fontWeight: 700 }}>
          {pagination.total}{" "}
          {pagination.total === 1 ? "participant" : "participants"}
        </Typography>
      </Box>

      <Box
        sx={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}
      >
        <StyledDataGrid
          sx={{
            flex: 1,
            "& .MuiDataGrid-row": { cursor: "pointer" },
            "& .MuiDataGrid-row:hover": {
              backgroundColor: "rgba(80, 0, 0, 0.04)",
            },
          }}
          rows={patients}
          columns={columns}
          pageSizeOptions={[10, 25, 50]}
          pagination
          paginationMode="server"
          sortingMode="server"
          rowCount={pagination.total}
          paginationModel={{
            page: pagination.page,
            pageSize: pagination.pageSize,
          }}
          onSortModelChange={(model) => {
            setSortModel(model);
            setPagination((prev) => ({ ...prev, page: 0 }));
          }}
          onPaginationModelChange={(model) => {
            setPagination((prev) => ({
              ...prev,
              page: model.page,
              pageSize: model.pageSize,
            }));
          }}
          disableSelectionOnClick
          loading={loading}
          onRowClick={(params) => handlePatientClick(params.row)}
        />
      </Box>
    </Box>
  );
};

export default PatientData;
